import { render, staticRenderFns } from "./NoAccount.vue?vue&type=template&id=60b5fd0c&"
import script from "./NoAccount.vue?vue&type=script&lang=js&"
export * from "./NoAccount.vue?vue&type=script&lang=js&"
import style0 from "./NoAccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports